import React from "react"
import FlaveRadioButtonCheckbox from "./flave_radio_button_checkbox";

const FlaveCheckbox = (props) => {
  return <FlaveRadioButtonCheckbox {...props} type={"checkbox"}/>
}

export default FlaveCheckbox
